import request from '@/utils/request'

//审批流程查询
export function getList(data) {
  return request({
    url: '/yzdservice/cjgly/splc/list',
    method: 'post',
    data
  })
}
//新增/修改审批流程
export function addOrUpdSave(data) {
  return request({
    url: '/yzdservice/cjgly/splc/addOrUpdSave',
    method: 'post',
    data
  })
}
//获取行政区划级联树
export function getXzqTree() {
  return request({
    method: 'get',
    url: "/organization/api/xzqh/splc/tree",
  })
}
//获取行政区划级联树
export function getXzqTreeS(id) {
  return request({
    method: 'get',
    url: "/organization/api/xzqh/tree/"+id,
  })
}
//查询化学品tree
export function getHxpTree() {
  return request({
    method: 'get',
    url: '/yzdservice/cjgly/splc/selHxpLb',
  })
}
//获取kv yzd_xb
export function selSplcYwlx() {
  return request({
    method: 'get',
    url: '/yzdservice/cjgly/splc/selSplcYwlx',
  })
}
//
export function selHxpXx(id) {
  return request({
    method: 'get',
    url: '/yzdservice/cjgly/splc/selHxpXx/'+id,
  })
}
